import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

import { getAmountWithSymbol } from 'components/event_type_edit'

import { isPayPalProvider } from './payment_provider_utils'
import { useDebouncedFormContext } from '../../hooks'

const getPaymentDisplayText = (provider, amountWithSymbol) => {
  const providerKey = isPayPalProvider(provider) ? 'paypal' : provider
  const providerMessages = {
    paypal: I18n.t('publisher.managed_event_types.payment.paypal', { amount: amountWithSymbol }),
    stripe: I18n.t('publisher.managed_event_types.payment.stripe', { amount: amountWithSymbol })
  }
  return providerMessages[providerKey] || amountWithSymbol
}

export const LockedCollectPaymentSection = ({ paymentMethodEnabled }) => {
  const { values } = useDebouncedFormContext()

  if (!paymentMethodEnabled) {
    return <BodyText>{I18n.t('publisher.managed_event_types.payment.no_payment')}</BodyText>
  }

  const { currency, provider, amount } = values
  const amountWithSymbol = getAmountWithSymbol({ currency, amount })

  return <BodyText>{getPaymentDisplayText(provider, amountWithSymbol)}</BodyText>
}
